import { useEffect, useRef } from 'react';
import { useOperationalStatus } from '../../hooks';
import { ConverseSocket } from '../ConverseSocket';
import { useAuth } from '../../contexts';
const maxSocketErrorsCount = 5;
export const useSocket = () => {
    const errorsCount = useRef(0);
    const socketRef = useRef();
    const [, setOperationalStatus] = useOperationalStatus();
    const { getToken } = useAuth();
    if (!socketRef.current) {
        socketRef.current = new ConverseSocket(getToken);
    }
    useEffect(() => {
        if (!socketRef.current) {
            return;
        }
        const onOpenRef = socketRef.current.onOpen(() => {
            errorsCount.current = 0;
            setOperationalStatus('normal');
        });
        const onCloseRef = socketRef.current.onClose(() => {
            // Degraded mode can be set after socket connection becomes unreachable
            // In degraded mode each query use own refresh interval to update the data
            setOperationalStatus('degraded');
        });
        const onErrorRef = socketRef.current.onError(() => {
            errorsCount.current += 1;
            if (errorsCount.current >= maxSocketErrorsCount) {
                socketRef.current?.disconnect();
                errorsCount.current = 0;
            }
        });
        return () => socketRef.current?.off([onOpenRef, onCloseRef, onErrorRef]);
    }, [setOperationalStatus]);
    return socketRef.current;
};
//# sourceMappingURL=useSocket.js.map